<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingSalesReports"
  >
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingSalesReports',

  data () {
    return {
      showLoadingState: true
    }
  }
}
</script>
